import React, { FC } from 'react';
import { Slider, SliderProps } from '@mui/material';

const OvSlider: FC<SliderProps> = ({ children, ...props }) => (
  <Slider {...props} />
);

export default OvSlider;
